export default {"src":"https://cdn.tanzhi.cn/_next/static/media/city.bba596d3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};